import { createValueFormatter, type ServerColDef } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export const valueFormatter = createValueFormatter<UnderwriterEmployeeFragment, string>();

const accountNameColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'userAccount.name',
  headerName: 'Account Name',
  minWidth: 200,
  valueFormatter,
};

export default accountNameColDef;
